export const baseUrlDev =
  "https://arena-fs.arenaplus.fastcloudnetwork.com/api/";
export const baseUrlProd = "https://app.tvhindulive.com/api/";
export const providerName = "https://arenaxui.fastcloudnetwork.com:25463";
export const reskinName = "hindu";
export const demo = false;
